import { render, staticRenderFns } from "./UpdatePermissions.vue?vue&type=template&id=3c28544f&scoped=true"
import script from "./UpdatePermissions.vue?vue&type=script&lang=js"
export * from "./UpdatePermissions.vue?vue&type=script&lang=js"
import style0 from "./UpdatePermissions.vue?vue&type=style&index=0&id=3c28544f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c28544f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c28544f')) {
      api.createRecord('3c28544f', component.options)
    } else {
      api.reload('3c28544f', component.options)
    }
    module.hot.accept("./UpdatePermissions.vue?vue&type=template&id=3c28544f&scoped=true", function () {
      api.rerender('3c28544f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/supper-system/UpdatePermissions.vue"
export default component.exports